import { DateRange, DateTime, TimeUnit } from '@cast/shared-types';

import { durationToUnit } from './date';

type GenerateForecastArgs<T, A = T> = {
  dateRange: DateRange;
  unit: TimeUnit;
  data: T[];
  zeroAgg?: (nextTimestamp: DateTime) => A;
  sum: (agg: A, item: T) => A;
  divide: (curr: A, count: number) => T;
  windowSize?: number;
};

export const generateForecast = <T, A = T>({
  dateRange: [from, to],
  unit,
  data,
  zeroAgg,
  sum,
  divide,
  windowSize,
}: GenerateForecastArgs<T, A>): T[] => {
  windowSize = windowSize ?? durationToUnit('7d', unit);
  const startFrom = zeroAgg ? 0 : 1;
  let generatingDate = from;
  while (to.isAfter(generatingDate)) {
    let agg = zeroAgg
      ? zeroAgg(generatingDate)
      : data[Math.max(data.length - windowSize, 0)];
    generatingDate = generatingDate.add(1, unit);
    let count = 0;
    for (
      let i = Math.max(data.length - windowSize + startFrom, startFrom);
      i < data.length;
      i++
    ) {
      agg = sum(agg as A, data[i]);
      count++;
    }
    if (count) {
      data.push(divide(agg as A, count));
    } else {
      break;
    }
  }
  return data;
};
